export const formatHourValue = (value, unit) => {
  if(value=='0' || value==0){
    return 0;
  }
  if(value=='' || value==null){
    return '';
  }
  if (unit === "hrs." && typeof value === 'number' && value > 0) {
    const hours = Math.floor(value);
    const minutes = Math.round((value - hours) * 60);
    if (hours === 0) {
      return `${minutes} min`;
    } else if (minutes === 0) {
      return `${hours} hrs`;
    } else {
      return `${hours} hrs ${minutes} min`;
    }
  }
  if (unit?.toLowerCase() === "percentage") {
    return value+'%';
  }
  if (unit?.toLowerCase() === "unit") {
    return  Math.round(value);
  }
  if (unit?.toLowerCase() === "decimal") {
    const numValue = parseFloat(value);
    return numValue % 1 === 0 ? numValue.toString() : numValue.toFixed(2);
  }
  return  value; 
};

export const getPopupTableColumnName = (activeOrganizationTab) => {
    switch(activeOrganizationTab) {
        case 'branches':
            return "Branch Name";
        case 'managers':
            return "Managers";
        case 'assistants':
            return "Assistants";
        case 'team_pods':
            return "Pods/Teams Name";
        default:
            return "Name";
    }
};